<template>
  <div
    class="w-full min-w-full bg-gradient-to-b from-gray-700 to-gray-900 overflow-hidden"
    style="height: 550px; max-height: 550px; min-height: 550px"
  >
    <transition name="fade">
      <div
        v-show="comparisonResults === null"
        id="particles-js"
        class="w-full min-w-full"
        style="height: 550px"
      />
    </transition>

    <transition name="fade">
      <div
        v-if="comparisonResults !== null && comparisonResults !== undefined && !reloadChart"
        class="w-full min-w-full h-full min-h-full flex items-center justify-center"
      >
        <Chart
          class="max-w-6xl ml-auto mr-auto"
          :class="selectedTab === 'Summary' ? '' : '-mt-4 mb-4'"
          :comparison-results="comparisonResults"
          :years="years"
          :selected-tab="selectedTab"
        />
      </div>
    </transition>
  </div>
</template>

<script>
  import ParticlesJS from 'particles.js';
  import Chart from './sd/sd.vue';

  export default {
    components: {
      Chart,
    },

    props: {
      comparisonResults: {
        type: Object,
        default: null,
      },
      years: {
        type: Number,
        default: 5,
      },
      selectedTab: {
        type: String,
        default: 'Summary',
      },
      reloadChart: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {};
    },

    watch: {
      reloadChart() {
        console.log('Hit');
        if (this.reloadChart) {
          setTimeout(() => this.$emit('chartReloaded'), 100);
        }
      },
    },

    mounted() {
      this.initParticleJS();
    },

    methods: {
      initParticleJS() {
        particlesJS('particles-js', {
          particles: {
            number: {
              value: 150,
              density: {
                enable: true,
                value_area: 800,
              },
            },
            color: {
              value: '#FFF',
            },
            shape: {
              type: 'circle',
              stroke: {
                width: 0,
                color: '#000000',
              },
              polygon: {
                nb_sides: 3,
              },
            },
            opacity: {
              value: 0.5,
              random: false,
              anim: {
                enable: false,
                speed: 1,
                opacity_min: 0.1,
                sync: false,
              },
            },
            size: {
              value: 3,
              random: true,
              anim: {
                enable: false,
                speed: 40,
                size_min: 0.1,
                sync: false,
              },
            },
            line_linked: {
              enable: true,
              distance: 150,
              color: '#FFF',
              opacity: 0.4,
              width: 1,
            },
            move: {
              enable: true,
              speed: 1,
              direction: 'none',
              random: false,
              straight: false,
              out_mode: 'out',
              bounce: false,
              attract: {
                enable: false,
                rotateX: 600,
                rotateY: 1200,
              },
            },
          },
          interactivity: {
            detect_on: 'canvas',
            events: {
              onhover: {
                enable: false,
                mode: 'grab',
              },
              onclick: {
                enable: true,
                mode: 'push',
              },
              resize: false,
            },
            modes: {
              grab: {
                distance: 140,
                line_linked: {
                  opacity: 1,
                },
              },
              bubble: {
                distance: 400,
                size: 40,
                duration: 2,
                opacity: 8,
                speed: 3,
              },
              repulse: {
                distance: 200,
                duration: 0.4,
              },
              push: {
                particles_nb: 4,
              },
              remove: {
                particles_nb: 2,
              },
            },
          },
          retina_detect: true,
        });
      },
    },
  };
</script>

